module.exports = __webpack_public_path__ + "static/media/outdoor-air.d7beae01.svg";